import React, { FC } from 'react'
import { FormikProps } from 'formik'
import Select, { ISelect } from '../Select'

export interface ISelectForm extends ISelect {
  formik: FormikProps<any>
  name: string
}

const SelectForm: FC<ISelectForm> = ({ formik, name, ...props }) => {
  const { setFieldValue, getFieldMeta } = formik;

  const changeField = (option: any) => {
    setFieldValue(name, option);
  };

  const {value} = getFieldMeta(name);

  return (
    <Select
      onChange={changeField}
      value={value || (props.options && props.options[0])}
      name={name}
      {...props}
    />
  );
};

export default SelectForm;
